import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";

import "@/assets/styles/base.css";
import "vue-loading-overlay/dist/vue-loading.css";

import 'core-js/stable'
import 'regenerator-runtime/runtime'

import * as VueGoogleMaps from "vue2-google-maps";

Vue.prototype.$http = axios;

Vue.use(VueGoogleMaps, {
    load: {
        key: process.env.VUE_APP_GOOGLE_MAPS_API_KEY,
        libraries: 'places'
    }
})

// disable vue production tip
Vue.config.productionTip = process.env.NODE_ENV === "production";

// eslint-disable-next-line no-console
console.log(
    `%c Post Office %c Branch Accessibility ${process.env.VERSION} %c ${process.env.NODE_ENV}`,
    "background:#cb1339; padding: 1px; border-radius: 3px 0 0 3px;  color: #fff",
    "background:#f5f5f5; padding: 1px; color: #000",
    "background:#4B0082; padding-right: 5px; border-radius: 0px 3px 3px 0px; color: #fff"
);

Vue.prototype.$scrollToTop = function() {
    var element = document.getElementById('top');
    var top = element.offsetTop;
    window.scrollTo(0, top);
}

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app");